// Main Location interface
export interface Location {
  locationCode: string;
  businessUnitId: string;
  isEnabledForBU: boolean;
  status: LocationStatus;
  region: string;
  country: string;
  state?: string;
  city?: string;
  postalCode?: string;
  createdBy: string;
  createdAt: string;
  lastUpdatedAt: string;
  lastUpdatedBy: string;
  changeLog: ChangeLogEntry[];
}

// Location Status Enum
export enum LocationStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

// ChangeLog Entry interface
export interface ChangeLogEntry {
  reason: string;
  changedBy: string;
  changedAt: string;
  version?: string;
  changedFields?: string[];
}

// Request Type
export interface ListLocationsRequest {
  businessUnitId: string;
  // Optional filters
  isEnabledForBU?: boolean;
  region?: string;
  country?: string;
  state?: string;
  maxResults?: number;
  nextToken?: string;
}

// Response Type
export interface ListLocationsResponse {
  __type: string;
  locations: Location[];
  nextToken?: string;
}

// Create Location Request Type
export interface CreateLocationRequest {
  businessUnitId: string;
  locationCode: string;
  region: string;
  country: string;
  state: string;
  isEnabledForBU: boolean;
  createdBy: string;
}
// Create Location Response Type
export interface CreateLocationResponse {
  businessUnitId: string;
  changeLog: any[]; // we can define specific type if needed
  country: string;
  createdAt: string;
  createdBy: string;
  isEnabledForBU: boolean;
  lastUpdatedAt: string;
  lastUpdatedBy: string;
  locationCode: string;
  region: string;
  state: string;
}

// Update Location Request Type
export interface UpdateLocationRequest {
  businessUnitId: string;
  locationCode: string;
  region?: string;
  country?: string;
  state?: string;
  isEnabledForBU?: boolean;
  lastUpdatedBy: string;
  reason: string;
}

// Update Location Response Type
export interface UpdateLocationResponse {
  location: Location;
}

export interface GetLocationRequest {
  businessUnitId: string;
  locationCode: string;
}
export interface GetLocationResponse {
  location: Location;
}
